import React from 'react'
import Main from './components/Main'
import HowItWorks from './components/HowItWorks'
import Coming from './components/Coming'
import Footer from './components/Footer'
import Navbar from './components/Navbar'
import Mains from './components/Mains'
import { Box, Typography } from '@mui/material'
import "./components/Main.css"

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useState, useEffect } from 'react';
import Login from './Pages/Login';
import './App.css'

import InnerNavbar from './components/InnerNavbar';
import SideBar from './components/SideBar';
import Home from './Pages/Home';
import Profile from './Pages/Profile/Profile';


import Changepassword from './Pages/Changepassword/Changepassword';
import Pagenotfound from './components/Pagenotfound';
import Department from './Pages/Department case/Department';
import Taskmanagement from './Pages/Task Management/Taskmanagement';

import Legalcalander from './Pages/Legalcalander/Legalcalander';

import Notifications from './Pages/Notifications/Notifications';


const App = () => {
  return (
    <div>
      <Navbar />
      <Coming />
      <Main />
      <Mains />
      <HowItWorks />

      <Footer />

    </div>
  )
}

export default App